import chunk from 'lodash/chunk';
import React, { Fragment } from 'react';
import DataLayerContainer from '../../containers/HeaderContainer/DataLayerContainer';
import { LayerContent, MenuEntry } from '../../provider/Typo3Provider/types';
import { FontIconKey, FontIconSpan, iconMapping } from '../FontIcon';
import { Column, Row } from '../Grid';
import {
  NavigationLink,
  NavigationList,
  NavigationListItem,
  NavigationWrapper
} from '../Navigation';
import { SvgIcon } from '../SvgIcon';
import { HtmlContent } from './HtmlContent';

interface NavigationGroupProps {
  entries: MenuEntry[];
  isMain?: boolean;
  layer?: LayerContent;
}

interface NavigationGroupChildrenProps {
  children: MenuEntry[];
}

const numChildrenPerColumn = 6;

const NavigationGroupChildren = ({
  children
}: NavigationGroupChildrenProps) => {
  const groups = chunk(children, numChildrenPerColumn);
  if (groups.length > 1) {
    return (
      <NavigationWrapper width={800}>
        <Row noGap>
          {groups.map((entries, i) => (
            <Column key={i} large={4}>
              <NavigationList>
                <NavigationGroup entries={entries} isMain />
              </NavigationList>
            </Column>
          ))}
        </Row>
      </NavigationWrapper>
    );
  }
  return (
    <NavigationWrapper>
      <NavigationGroup entries={children} isMain />
    </NavigationWrapper>
  );
};

const NavigationGroup = ({
  entries,
  isMain = false,
  layer
}: NavigationGroupProps) => {
  return (
    <Fragment>
      {entries.map((entry, index) => {
        // #40334
        const IconComponent =
          entry.icon && entry.icon in iconMapping ? FontIconSpan : 'span';
        // we can do this, because the `icon` attribute would be
        // ignored by the `span` element
        // and `FontIconSpan` would only be selected
        // if the `entry`'s  `icon` appears in `iconMapping`
        const icon: FontIconKey = entry.icon as any;

        return (
          <NavigationListItem key={index}>
            <NavigationLink to={entry.link}>
              {isMain && <SvgIcon icon="arrow" />}
              <IconComponent icon={icon}>
                <HtmlContent htmlString={entry.title} />
              </IconComponent>
            </NavigationLink>
            {entry.children && (
              <NavigationGroupChildren children={entry.children} />
            )}
            {entry.layout === '11' && !!layer && (
              <NavigationWrapper>
                <DataLayerContainer layer={layer} />
              </NavigationWrapper>
            )}
          </NavigationListItem>
        );
      })}
    </Fragment>
  );
};

export default NavigationGroup;
